import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetReceiptsSettingsApplicationErrors,
  GetReceiptsSettingsResponse,
  ReceiptsSettings,
  ReceiptsSettingsUpdatedEnvelope,
  UpdateReceiptsSettingsApplicationErrors,
  getReceiptsSettings as universalGetReceiptsSettings,
  updateReceiptsSettings as universalUpdateReceiptsSettings,
} from './receipts-v1-receipts-settings-receipts-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/get-paid' };

export function getReceiptsSettings(
  httpClient: HttpClient
): GetReceiptsSettingsSignature {
  return () =>
    universalGetReceiptsSettings(
      // @ts-ignore
      { httpClient }
    );
}

interface GetReceiptsSettingsSignature {
  /**
   * Retrieves a site's receipt settings.
   */
  (): Promise<
    GetReceiptsSettingsResponse & {
      __applicationErrorsType?: GetReceiptsSettingsApplicationErrors;
    }
  >;
}

export function updateReceiptsSettings(
  httpClient: HttpClient
): UpdateReceiptsSettingsSignature {
  return (
    receiptsSettings: NonNullablePaths<
      ReceiptsSettings,
      `numbering` | `revision`,
      2
    >
  ) =>
    universalUpdateReceiptsSettings(
      receiptsSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateReceiptsSettingsSignature {
  /**
   * Updates a site's receipt settings, or creates them if none exist.
   * @param - Receipt settings to update. Partial update is supported, but if no receipt settings entity exists, the full entity must be specified.
   * @returns Updated receipt settings.
   */
  (
    receiptsSettings: NonNullablePaths<
      ReceiptsSettings,
      `numbering` | `revision`,
      2
    >
  ): Promise<
    ReceiptsSettings & {
      __applicationErrorsType?: UpdateReceiptsSettingsApplicationErrors;
    }
  >;
}

export const onReceiptsSettingsUpdated = EventDefinition(
  'wix.receipts.v1.receipts_settings_updated',
  true,
  (event: ReceiptsSettingsUpdatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'metadata.eventTime' },
            { path: 'modifiedFields.createdDate' },
            { path: 'modifiedFields.updatedDate' },
          ],
        },
      ])
    )
)<ReceiptsSettingsUpdatedEnvelope>();

export {
  AccountInfo,
  AccountInfoMetadata,
  ActionEvent,
  BaseEventMetadata,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  EventMetadata,
  ExtendedFields,
  GetReceiptsSettingsRequest,
  GetReceiptsSettingsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  MessageEnvelope,
  NextNumberDescendingErrorDetails,
  Numbering,
  ReceiptsSettings,
  ReceiptsSettingsUpdatedEnvelope,
  RestoreInfo,
  UpdateReceiptsSettingsRequest,
  UpdateReceiptsSettingsResponse,
  WebhookIdentityType,
} from './receipts-v1-receipts-settings-receipts-settings.universal.js';
